export const SIGMA_SIGNIN_REQUEST_PATH = "/api/auth/sign-in/sigma";
export const SIGMA_SIGNUP_REQUEST_PATH = "/api/auth/sign-up/sigma";

export interface SigmaSigninBody {
	bapId: string;
	intent?: "sign-up";
}

/**
 * Canonical JSON covered by the Bitcoin-Auth signature.
 * Keep field order stable for non-browser clients that implement this contract.
 */
export function serializeSigmaSigninBody(body: SigmaSigninBody): string {
	return JSON.stringify({
		bapId: body.bapId,
		...(body.intent === "sign-up" ? { intent: body.intent } : {}),
	});
}
